import {
  useGetAchievementCatalogQuery,
  useGetUserAchievementsQuery,
} from '@/redux/achievement/achievement.api.slice';
import { AchievementDefinition } from '@/redux/achievement/achievement.types';

export type BadgeState = 'earned' | 'locked' | 'soon';

export const stateOf = (
  entry: AchievementDefinition,
  earned: Set<string>
): BadgeState => {
  if (earned.has(entry.id)) return 'earned';
  return entry.available ? 'locked' : 'soon';
};

/** Null while loading. */
export function useProfileAchievements(username: string) {
  const { data: catalog } = useGetAchievementCatalogQuery();
  const { data: mine } = useGetUserAchievementsQuery(username, {
    refetchOnMountOrArgChange: true,
  });
  if (!catalog || !mine) return null;
  return {
    catalog,
    earned: new Set(mine.earned.map((row) => row.achievementId)),
    totalPoints: mine.totalPoints,
  };
}
